export default __webpack_public_path__ + "static/media/home.aa6e4426.svg";